"use strict";
var $ = require("jquery");
var _ = require("lodash");
var moment = require("moment");
var DateTimeUtils = (function () {
    function DateTimeUtils() {
    }
    DateTimeUtils.displayTime = function ($container) {
        if ($container === void 0) { $container = null; }
        var $items;
        if (_.isElement($container)) {
            $items = $container.find("span[data-time]");
        }
        else {
            $items = $("span[data-time]");
        }
        $items.each(function (index, el) {
            var $el = $(el), value = $el.attr("data-time"), format = $el.attr("data-format"), showOnlyHint = $el.attr("data-only-hint");
            var time = moment(value, moment.ISO_8601, true);
            var formattedText;
            if (format === undefined || format === null || format.indexOf("calendar") !== -1) {
                formattedText = DateTimeUtils.formatCalendar(time, format);
            }
            else if (format === "from-now") {
                formattedText = time.fromNow();
            }
            else {
                formattedText = time.format(format);
            }
            var currentTite = $el.attr("data-hint") || "";
            var formattedTextTitle = format == "calendar-without-time" ? time.format("D MMMM YYYY") : time.format("D MMMM YYYY в HH:mm:ss");
            if (currentTite.indexOf(formattedTextTitle) === -1) {
                $el.attr("data-hint", currentTite + formattedTextTitle);
            }
            if (showOnlyHint) {
                return;
            }
            var initialHtml = $el.html();
            if (initialHtml.indexOf(formattedText) === -1) {
                $el.html(initialHtml + formattedText);
            }
        });
    };
    DateTimeUtils.formatCalendar = function (time, format) {
        if (!time.isValid())
            return "";
        if (format == 'calendar-without-time') {
            return time.format("D.MM.YY");
        }
        if (format === "calendar-xs") {
            if (time.year() !== moment().year()) {
                return time.format("D.MM.YY");
            }
            return time.calendar(null, {
                sameDay: "HH:mm",
                lastDay: "вчера",
                lastWeek: "D MMM",
                sameElse: "D MMM"
            });
        }
        if (format === "calendar-sm") {
            if (time.year() !== moment().year()) {
                return time.format("D.MM.YY[<br/>]HH:mm");
            }
            return time.calendar(null, {
                sameDay: "HH:mm",
                lastDay: "вчера[<br/>]HH:mm",
                lastWeek: "D MMM[<br/>]HH:mm",
                sameElse: "D MMM[<br/>]HH:mm"
            });
        }
        var formattedText;
        if (time.year() !== moment().year()) {
            return time.format(this.defaultFormat);
        }
        if (format === "calendar-short") {
            formattedText = time.calendar(null, {
                sameDay: "сегодня в HH:mm",
                lastDay: "вчера в HH:mm",
                lastWeek: "D MMMM",
                sameElse: "D MMMM"
            });
        }
        else {
            formattedText = time.calendar(null, {
                sameDay: "сегодня в HH:mm",
                lastDay: "вчера в HH:mm",
                lastWeek: "D MMMM в HH:mm",
                nextDay: "[завтра в] HH:mm",
                nextWeek: "D MMMM в HH:mm",
                sameElse: "D MMMM в HH:mm"
            });
        }
        return formattedText;
    };
    DateTimeUtils.defaultFormat = "D MMMM YYYY";
    return DateTimeUtils;
}());
_.extend(window["AppUtils"], {
    DateTime: DateTimeUtils
});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = DateTimeUtils;
//# sourceMappingURL=dateTimeUtils.js.map